import { Outlet } from "react-router-dom";
import ImageSlider from "./image-slider";
import { useQueryFeatureImages } from "@/hooks/use-feature-images";
import { Loader2 } from "lucide-react";

const OpenContainer = () => {
  const featureImagesQuery = useQueryFeatureImages();

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-100">
      {/* <div className="flex bg-white rounded-2xl shadow-xl overflow-hidden w-full max-w-[1024px] sm:w-3/4 md:w-2/3 lg:w-1/2 h-auto min-h-[400px] md:min-h-[500px] lg:min-h-[600px] md:m-0 m-10"> */}
      <div className="h-[600px] px-5 md:min-w-[750px] lg:min-w-[900px]">
        <div className="flex size-full overflow-hidden rounded-2xl bg-white shadow-xl">
          <div className="relative hidden w-1/2 md:block">
            {featureImagesQuery.data && (
              <ImageSlider images={featureImagesQuery.data} />
            )}
            {featureImagesQuery.isLoading && (
              <div className="flex size-full items-center justify-center">
                <Loader2
                  aria-hidden="true"
                  className="size-10 animate-spin text-primary motion-reduce:animate-none"
                />
              </div>
            )}
            {/*
              4.1.3 Status Messages — AA. A bare spinner is silent to screen readers.
              The region is mounted unconditionally and only its text changes — a live
              region inserted into the DOM already containing its message is not
              announced, which is why this is not nested inside the isLoading branch.
            */}
            <div role="status" aria-live="polite" className="sr-only">
              {featureImagesQuery.isLoading ? "Loading images" : ""}
            </div>
          </div>
          <div className="relative h-full md:w-1/2">
            {/* <AnimatedContainer> */}
            <Outlet />
            {/* </AnimatedContainer> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OpenContainer;
